<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Tesorería</li>
        <li class="breadcrumb-item active" aria-current="page">Retiros realizados a Instaladores</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Retiros a Instalador</div>
            <div class="card-body">
              <withdrawals-finder
                @onSubmit="search"
                label="Nombre o Razón social, RFC, email, SID, UID"></withdrawals-finder>

              <div class="withdrawals-investor">
                <vs-table class="table table-sm" :data="withdrawals">
                  <template slot="thead" class="thead-dark">
                    <vs-th>TRX</vs-th>
                    <vs-th>PID</vs-th>
                    <vs-th>Procesador</vs-th>
                    <vs-th>Trans. ID</vs-th>
                    <vs-th>Alias</vs-th>
                    <vs-th>SID</vs-th>
                    <vs-th>Nombre</vs-th>
                    <vs-th>Concepto</vs-th>
                    <vs-th>Monto</vs-th>
                    <vs-th>P. Factura</vs-th>
                    <vs-th>Meses</vs-th>
                    <vs-th>Estatus</vs-th>
                    <vs-th>F. Confirmación</vs-th>
                    <vs-th>Factura</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr v-bind:key="wd.id" v-for="(wd, index) in data">
                      <vs-td>{{ wd.trx.type }}</vs-td>
                      <vs-td>{{ wd.project.id }}</vs-td>
                      <vs-td>{{ wd.payment_transaction.provider }}</vs-td>
                      <vs-td>{{ wd.payment_transaction.id }}</vs-td>
                      <vs-td>{{ wd.project.alias }}</vs-td>
                      <vs-td>{{ wd.supplier_id }}</vs-td>
                      <vs-td>{{ wd.fiscal_name }}</vs-td>
                      <vs-td>{{ wd.trx.concept }}</vs-td>
                      <vs-td>{{ wd.trx.amount|currency }}</vs-td>
                      <vs-td>{{ wd.total_cost|currency }}</vs-td>
                      <vs-td>{{ wd.term }}</vs-td>
                      <vs-td>{{ wd.trx.status }}</vs-td>
                      <vs-td>{{ wd.payment_transaction.operation_date|humanizeDate }}</vs-td>
                      <vs-td>
                        <template v-if="hasChargeCommissionInvoice(wd)">
                          <button
                            @click="open(wd, user)"
                            class="btn btn-default btn-sm btn-raised">
                            XML
                          </button>
                          <button
                            @click="open(wd, user)"
                            class="btn btn-default btn-sm btn-raised">
                            PDF
                          </button>
                        </template>
                        <br>

                        <!-- Project Invoices -->
                        <button
                          v-if="wd.project_invoice.pdf_file !== '' && wd.project_id !== ''"
                          @click="openProjectInvoice(wd.project_invoice.pdf_file, user)"
                          class="btn btn-default btn-sm btn-raised">
                          PDF Factura Proyecto
                        </button>
                        <br>
                        <button
                          v-if="wd.project_invoice.xml_file !== '' && wd.project_id !== ''"
                          @click="openProjectInvoice(wd.project_invoice.xml_file, user)"
                          class="btn btn-default btn-sm btn-raised">
                          XML Factura Proyecto
                        </button>
                        <!-- Project Invoices -->
                      </vs-td>
                      <template slot="expand">
                        <div class="con-expand-users w-full">
                          <vs-table :data="[{}]">
                            <template slot="thead">
                              <vs-th>TRX</vs-th>
                              <vs-th>Concepto</vs-th>
                              <vs-th>Monto</vs-th>
                              <vs-th>Estatus</vs-th>
                            </template>
                            <template v-if="wd.transactions">
                              <vs-tr v-for="c in wd.transactions" v-bind:key="'c-' + c.id" class="trx-child">
                                <vs-td>{{ c.trx_type }}</vs-td>
                                <vs-td>{{ c.concept }}</vs-td>
                                <vs-td align="right">{{ c.amount|currency }}</vs-td>
                                <vs-td>{{ c.status }}</vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </template>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

let WithdrawalsFinder = require('./withdrawals-finder').default;
import {SupplierWithdrawals} from "@/bl/withdrawals/SupplierWithdrawals";
import {AxiosErrorException} from '../functions/axiosErrorException';
import {humanizeDate} from "@/filters/momentTzConvert";

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    variant: {
      type: String,
      default: "withdrawsModule"
    }
  },
  components: {
    'withdrawals-finder': WithdrawalsFinder
  },
  data() {
    return {
      withdrawals: []
    }
  },
  filters: {
    humanizeDate,
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  async mounted() {
    try {
      await this.getWithdrawals(this.filters);
    } catch (err) {
      await swal('Ups!', AxiosErrorException(err), 'error')
    }
  },
  methods: {
    open(wd, user) {
      window.open(
        `${this.StorageURL}/storage/private/rg-invoice/0/${this.getChargeCommissionInvoice(wd).pdf_file}?access_token=${user.access_token}`,
        '_blank'
      )
    },
    openProjectInvoice(file, user) {
      window.open(
        `${this.StorageURL}/storagev3/documents${file}?access_token=${user.access_token}`,
        '_blank'
      )
    },
    hasChargeCommissionInvoice(trxItem) {
      let invoice = this.getChargeCommissionInvoice(trxItem);
      return invoice !== null;
    },
    getChargeCommissionInvoice(trxItem) {
      let S260 = trxItem.transactions.filter((trx) => trx.trx_type === "S260");
      if(S260.length > 0) {
        return S260[0].commission.invoice;
      }
      return null;
    },
    search(e) {
      try {
        let filters = {...e, ...this.filters};
        this.getWithdrawals(filters);
      } catch (err) {
        swal('Ups!', AxiosErrorException(err), 'error')
      }
    },
    async getWithdrawals(filters) {
      let wd = new SupplierWithdrawals();
      let res = await wd.get(filters)
      this.withdrawals = res.data;
    }
  }
}
</script>
<style scoped>
tbody.collapse {
  display: none;
}
</style>
